import React, { useState } from "react";
import { Button, Empty, Input } from "antd";
import { AppstoreOutlined, PlusOutlined } from "@ant-design/icons";

import DrinkTable from "../components/drinks/DrinkTable";
import CreateDrink from "../components/drinks/CreateDrink";
import useDrink from "../hooks/useDrink"; //  create similar to useMenu

import { nowDate } from "../components/Customs/nowDate";
import { notify } from "../components/Customs/NotifyProvider";

import {
  canViewModule,
  canCreateModule,
  canUpdateModule,
  canDeleteModule,
} from "../utils/permissionUtils";

const MODULE_KEY = "manage_drink";

const ManageDrink = () => {
  const {
    drinks,
    fetchDrinks,
    loading,
    createDrink,
    updateDrink,
    deleteDrink,
    cat,
  } = useDrink();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingDrink, setEditingDrink] = useState(null);
  const [searchText, setSearchText] = useState("");

  //  PERMISSION
  if (!canViewModule(MODULE_KEY)) {
    return (
      <div className="page-shell user-master-page">
        <div className="page-empty">
          <Empty description="No permission to view drink page" />
        </div>
      </div>
    );
  }

  //  SEARCH
  const filteredDrinks = drinks.filter((drink) =>
    Object.values(drink).some((val) =>
      String(val).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  //  CREATE
  const openCreate = () => {
    if (!canCreateModule(MODULE_KEY)) {
      notify.error("Permission Denied", "No permission to create drink");
      return;
    }

    setEditingDrink(null);
    setDrawerOpen(true);
  };

  //  EDIT
  const openEdit = (drink) => {
    if (!canUpdateModule(MODULE_KEY)) {
      notify.error("Permission Denied", "No permission to update drink");
      return;
    }

    setEditingDrink(drink);
    setDrawerOpen(true);
  };

  //  DELETE
  const handleDelete = async (id) => {
    if (!canDeleteModule(MODULE_KEY)) {
      notify.error("Permission Denied", "No permission to delete drink");
      return;
    }

    await deleteDrink(id);
    fetchDrinks();
  };

  //  SAVE
  const handleSubmit = async (values) => {
    const req = {
      ...values,
      created_at: nowDate(),
      updated_at: nowDate(),
    };

    const reqUpdate = {
      ...values,
      updated_at: nowDate(),
    };

    if (editingDrink) {
      await updateDrink(editingDrink.id, reqUpdate);
    } else {
      await createDrink(req);
    }

    fetchDrinks();
    setDrawerOpen(false);
  };

  return (
    <div className="page-shell user-master-page">

      {/* HEADER */}
      <div className="user-page-header">
        <div className="user-page-header-left">
          <div className="user-page-icon">
            <AppstoreOutlined />
          </div>

          <div>
            <h2 className="user-page-title">Manage Drinks</h2>
            <p className="user-page-subtitle">
              Create, update, and manage all drinks items.
            </p>
          </div>
        </div>

        <div className="user-page-header-actions" style={{ display: "flex" }}>
          <Input
            placeholder="Search drink..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="large"
            style={{ width: 500, marginRight: 10 }}
          />

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={openCreate}
            disabled={!canCreateModule(MODULE_KEY)}
          >
            Create Drinks
          </Button>
        </div>
      </div>

      {/* TABLE */}
      <div className="page-card table-card">
        <div className="table-card-header">
          <div>
            <h3>Drinks List</h3>
            <p>View and manage drinks inventory.</p>
          </div>
        </div>

        <DrinkTable
          data={filteredDrinks}
          loading={loading}
          onEdit={openEdit}
          onDelete={handleDelete}
          cat={cat}
        />
      </div>

      {/* DRAWER */}
      <CreateDrink
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editingDrink}
        cat={cat}
      />
    </div>
  );
};

export default ManageDrink;